"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductsSummaryStreamResponse = exports.getProductsSummaryStream = void 0;
const ndjson_1 = require("ndjson");
const routes_1 = require("../../routes");
const getProductsSummaryStream = (client) => async () => {
    const response = await (0, exports.getProductsSummaryStreamResponse)(client)();
    return response.data.pipe((0, ndjson_1.parse)());
};
exports.getProductsSummaryStream = getProductsSummaryStream;
const getProductsSummaryStreamResponse = (client) => async () => {
    const response = await client.get(routes_1.ENDPOINTS.GET_PRODUCTS_SUMMARY.path, {
        headers: {
            accept: 'application/x-ndjson',
        },
        responseType: 'stream',
    });
    return response;
};
exports.getProductsSummaryStreamResponse = getProductsSummaryStreamResponse;
